<template>
  <div class="ismodal" v-if="istrr">
      <div v-for="(popup, idx) in popups" :key="idx">
        <template>
        <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
            <div  v-if="showModal(popup.noticeNo)" :id="popup.noticeNo" :ref="popup.noticeNo"  :style="positionL(idx)">
                <div class="ismodalHeader">
                    <span>▣ 공지사항</span>
                </div>
                <div class="modalbodys">
                    <img class="imgtt" @click="popupGoPage(popup.noticeNo,popup.published)" :src="popup.imageUrl"/>
                </div>
                <div class="ismodalFooter">
                    <b-button @click="hideModal(popup.noticeNo)">닫기</b-button>
                    <b-button variant="outline-primary" :nono="popup.noticeNo" @click="setCookie(popup.noticeNo, 'event0405', 1, popup.noticeNo) ">오늘은 그만보기</b-button>
                </div>
            </div>
        </b-row>
        </template>
    </div>
  </div>
</template>

<script>

import mixin from '../utils/mixins';

export default {
    mixins: [mixin],
    data(){
        return{
            ismodal:"false",
            thisIds:[],
            abs:{
                position: 'absolute',
                top: '50px',
                left: '50px',
            },
        }
    },
    components:{
        
    },

    methods:{
        positionL(idx){
            return{
                position: 'absolute',
                top: '50'*idx +"px",
                left: '50'*idx +"px",
                width: '650px',
                background: '#fff',
                border: '1px solid #c11314',
            }
        },
        showModal(noticeNo){
            // console.log(this.getCookie(noticeNo))
            if(this.getCookie(noticeNo) !="event0405" || sessionStorage.getItem(noticeNo) != "event0405"){
                return true;
            }else{
               return false;
            }
        },
        setCookie: function(name, value, exp,noticeNo) {
            let date = new Date();
            date.setTime(date.getTime() + exp*24*60*60*1000);
            document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';';
            sessionStorage.setItem(name, value);
            this.hideModal(noticeNo)
        },
        getCookie(name) {
            var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return value? value[2] : null;
        },
        popupGoPage(noticeNo,published){
            console.log(this.popups)
            if(published == true){
                this.istrr = false;
                this.$router.push('/'+this.siteName+'/notice/NoticeDetail?query='+noticeNo);

            }else{
                alert('해당 팝업에 대한 공지사항이 없습니다.')
                console.log(this.popup)
            }
        }
    },
}
</script>

<style scoped>
.ismodal {
    position: absolute;
    z-index: 999999;
    top: 0px;
}

.ismodal > div {
    min-width: 650px;
    width: 100%;
    height: 100%;
    background: #fff;
    position: absolute;
    top: 0;
}
.ismodalHeader {
    background: #c11314;
    color: #fff;
    font-size: 16px;
    padding: 10px 20px;
}
.ismodalFooter {
    background: #fff;
    text-align: right;
    margin-top: 20px;
    margin: 20px;
}
.imgwarp{
    width: 100%;
    position: relative;
}
.imgtt{
    position: relative;
    width: 100%;
    cursor: pointer;
}
.modalbodys {
    background: #fff;
    padding: 20px;
}
</style>